import { render, staticRenderFns } from "./TaskStatusSelector.vue?vue&type=template&id=305b350b&scoped=true&"
import script from "./TaskStatusSelector.vue?vue&type=script&lang=js&"
export * from "./TaskStatusSelector.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusSelector.vue?vue&type=style&index=0&id=305b350b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b350b",
  null
  
)

export default component.exports